import { IComponentOptions } from "angular";
import { MachineConfigurationTypeInfoProgressiveGamesComponentController } from "./controller";

export const vsComponentName =
  "machineConfigurationTypeInfoProgressiveGamesComponent";

export const machineConfigurationTypeInfoProgressiveGamesComponentOptions: IComponentOptions =
  {
    controller: MachineConfigurationTypeInfoProgressiveGamesComponentController,
    controllerAs: "progressiveGamesController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      progressiveGames: "<",
      machineConfigurationType: "<",
    },
  };
